// WORDS FOR THE KYCKCONNECT DASHBOARD AND REPORTS (Phase 3). PURE. ⚠️ An unmeasured figure is a dash, never 0: `null` in, "-" out.
export const NONE = '-';

export function formatSeconds(s: number | null): string {
  if (s === null) return NONE;
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${String(s % 60).padStart(2, '0')}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${String(m % 60).padStart(2, '0')}m`;
}

export const formatPct = (p: number | null): string => (p === null ? NONE : `${p % 1 === 0 ? p.toFixed(0) : p.toFixed(1)}%`);

export const formatCount = (n: number | null): string => (n === null ? NONE : n.toLocaleString('en-AU'));

/** "Mon 3 Nov, 2:30 pm" in the booking's own zone. */
export function formatWhen(iso: string, timezone: string): string {
  try {
    return new Intl.DateTimeFormat('en-AU', { timeZone: timezone, weekday: 'short', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' }).format(new Date(iso));
  } catch {
    return iso;
  }
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;

/** A short axis label for a bucket key: `YYYY-MM` -> "Mar 26", `YYYY-MM-DD` -> "9 Mar". A key it cannot read comes back unchanged. */
export function bucketLabel(key: string): string {
  const m = /^(\d{4})-(\d{2})(?:-(\d{2}))?$/.exec(key);
  if (!m) return key;
  const month = MONTHS[Number(m[2]) - 1];
  if (!month) return key;
  return m[3] ? `${Number(m[3])} ${month}` : `${month} ${m[1]!.slice(2)}`;
}

/** "3pm", "12am": the heatmap's hour labels. */
export function hourLabel(h: number): string {
  const ampm = h < 12 ? 'am' : 'pm';
  const n = h % 12 === 0 ? 12 : h % 12;
  return `${n}${ampm}`;
}
